module.exports = __webpack_public_path__ + "img/02.716336a3.jpg";